import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CreateEmployeeInvestigationCommand } from '../../../domain/commands';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { CreateInvestigationResult } from '../create/create-investigation.result';

@Injectable({ providedIn: 'root' })
export class CreateEmployeeInvestigationUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(command: CreateEmployeeInvestigationCommand): Observable<CreateInvestigationResult> {
    this._state.setSavingInvestigation(true);
    this._state.setErrorInvestigation(null);

    return this._repository.createEmployeeInvestigation(command).pipe(
      tap(() => this._state.setSavingInvestigation(false)),
      map((result) => ({
        investigationId: result.investigationId,
        investigationNumber: result.investigationNumber,
      })),
      catchError((error) => {
        this._state.setErrorInvestigation(error.message ?? 'Failed to create investigation');
        this._state.setSavingInvestigation(false);
        return throwError(() => error);
      }),
    );
  }
}
